import PropTypes from 'prop-types';
import {createContext, useContext} from 'react';

/**
 * When true, Blog Grid section CTAs stay in the footer — do not merge into BlogSummary tiles.
 * EditorialWrapper sets this around embedded grids.
 */
const BlogGridInlineCtaEditorialSuppressContext = createContext(false);

export const useBlogGridInlineCtaSuppressedByEditorial = () =>
  useContext(BlogGridInlineCtaEditorialSuppressContext);

export const BlogGridInlineCtaEditorialSuppressProvider = ({children}) => (
  <BlogGridInlineCtaEditorialSuppressContext.Provider value>
    {children}
  </BlogGridInlineCtaEditorialSuppressContext.Provider>
);

BlogGridInlineCtaEditorialSuppressProvider.propTypes = {
  children: PropTypes.node,
};
